export const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  localStorage.removeItem('userAvatar')
  
  window.location.href = '/login'
}